function sumNumbersInArr(arr) {
  return arr.reduce((a, b) => a + b, 0);
}

export default {
  sumNumbersInArr
};
